import script from "./JobPost.vue?vue&type=script&lang=ts&setup=true"
export * from "./JobPost.vue?vue&type=script&lang=ts&setup=true"

import "./JobPost.vue?vue&type=style&index=0&id=59a24c2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a24c2e"]])

export default __exports__